module.exports = __webpack_public_path__ + "img/logo_spine.936d614e.png";